/** @format */
import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import { SimCardServiceTypeAllowedParam, SimCardServiceTypeParam } from '../../../../interfaces/collections/SimCardServiceInterface';
import GridContainer from '../../../../components/Grid/GridContainer';
import { DefaultInput } from './SimCardServiceTypeForm/DefaultInput';
import { RadioInput } from './SimCardServiceTypeForm/RadioInput';
import { SelectInput } from './SimCardServiceTypeForm/SelectInput';
import { NumericInput } from './SimCardServiceTypeForm/NumericInput';
import { MultiInputAnyChar } from './SimCardServiceTypeForm/MultiInputAnyChar';

const _ = require('underscore');

type OplSimCardServiceTypeParamItemSdgFormServicePDP5Type = {
    simCardServiceTypeAllowedParam: SimCardServiceTypeAllowedParam;
    simCardServiceTypeParam?: SimCardServiceTypeParam;
    getFormValues: (formValues: any) => void;
};

interface ParameterSDGInterface {
    required: boolean;
    param_name: string;
    default: string | number | boolean;
    type: string;
    allowedValue?: Array<any> | null;
    input?: string | null;
}

const FORM_CONSTANTS = {
    SELECT: 'select',
    RADIO: 'radio',
    READ_ONLY: 'readonly',
    NUMERIC: 'numeric',
    STRING: 'string',
};

export const OplSimCardServiceTypeParamItemSdgServicePDP5Form: FunctionComponent<OplSimCardServiceTypeParamItemSdgFormServicePDP5Type> = ({
    simCardServiceTypeAllowedParam,
    getFormValues,
    simCardServiceTypeParam,
}): React.ReactElement => {
    const [formValues, setFormValues] = useState<any>(null);

    const createDefaultFormValues = useCallback(
        (paramName: string, objectValue: object): object => {
            return { ...formValues, [paramName]: objectValue };
        },
        [formValues]
    );

    const getValues = (paramName: string, values: any): void => {
        setFormValues({ ...formValues, [paramName]: { ...formValues[paramName], ...values } });
    };

    const getProperComponent = (
        parameter: ParameterSDGInterface,
        parameterKey: string,
        assignedValue?: ParameterSDGInterface
    ): React.ReactElement => {
        let component: any = null;
        if (parameter.param_name === 'APN_NAME') {
            component = (
                <DefaultInput parameter={parameter} parameterKey={parameterKey} createValuesFromForm={getValues} assignedValue={assignedValue} />
            );
        } else {
            if (!parameter.input) {
                component = (
                    <DefaultInput parameter={parameter} parameterKey={parameterKey} createValuesFromForm={getValues} assignedValue={assignedValue} />
                );
            } else {
                switch (parameter.input) {
                    case FORM_CONSTANTS.RADIO:
                        component = (
                            <RadioInput
                                parameter={parameter}
                                parameterKey={parameterKey}
                                createValuesFromForm={getValues}
                                assignedValue={assignedValue}
                            />
                        );
                        break;
                    case FORM_CONSTANTS.SELECT:
                        component = (
                            <SelectInput
                                parameter={parameter}
                                parameterKey={parameterKey}
                                createValuesFromForm={getValues}
                                assignedValue={assignedValue}
                            />
                        );
                        break;
                    case FORM_CONSTANTS.STRING:
                        component = (
                            <DefaultInput
                                parameter={parameter}
                                parameterKey={parameterKey}
                                createValuesFromForm={getValues}
                                assignedValue={assignedValue}
                            />
                        );
                        break;
                    case FORM_CONSTANTS.NUMERIC:
                        component = (
                            <NumericInput
                                parameter={parameter}
                                parameterKey={parameterKey}
                                createValuesFromForm={getValues}
                                assignedValue={assignedValue}
                            />
                        );
                        break;
                    case FORM_CONSTANTS.READ_ONLY:
                        component = (
                            <SelectInput
                                parameter={parameter}
                                parameterKey={parameterKey}
                                createValuesFromForm={getValues}
                                assignedValue={assignedValue}
                                readOnly={true}
                            />
                        );
                        break;
                    default:
                        component = null;
                }
            }
        }
        return component;
    };

    const getForm = (): Array<object> => {
        const arr = [];
        let assignedValues = null;
        if (simCardServiceTypeParam) {
            assignedValues = JSON.parse(simCardServiceTypeParam.parameters);
        }
        for (const [key, value] of Object.entries(JSON.parse(simCardServiceTypeAllowedParam.parameters))) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            const x = getProperComponent(value, key, assignedValues ? assignedValues[key] : null);
            arr.push(x);
        }
        return arr;
    };

    useEffect(() => {
        if (!formValues) {
            let arr = {};
            if (!simCardServiceTypeParam) {
                for (const [key, value] of Object.entries(JSON.parse(simCardServiceTypeAllowedParam.parameters))) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    const x = createDefaultFormValues(key, value);
                    arr = { ...arr, ...x };
                }
            } else {
                const assignedValues = JSON.parse(simCardServiceTypeParam.parameters);
                for (const [key, value] of Object.entries(JSON.parse(simCardServiceTypeAllowedParam.parameters))) {
                    const z = {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                        // @ts-ignore
                        ...value,
                        ...assignedValues[key],
                    };
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    const x = createDefaultFormValues(key, z);
                    arr = { ...arr, ...x };
                }
            }
            setFormValues(arr);
        }
    }, [formValues, createDefaultFormValues, simCardServiceTypeAllowedParam, simCardServiceTypeParam]);

    useEffect(() => {
        getFormValues(formValues);
    }, [formValues, getFormValues]);

    return <GridContainer>{getForm()}</GridContainer>;
};
